import {ShippingMethod, ShippingMethodCode} from '@/store/models';

export function decode(methodCode: string): ShippingMethodCode {
    const exploded = methodCode.split('_');
    let code = exploded[1];

    if (exploded.length === 3) {
        code += `_${exploded[2]}`;
    }

    return {
        carrier_code: exploded[0],
        method_code: code,
    };
}

export function encode(method: ShippingMethodCode): string {
    return `${method.carrier_code}_${method.method_code}`;
}

export function getSimilarMethod(methodCode: string, shippingMethods: ShippingMethod[]): false | ShippingMethodCode {
    const decodedMethod = decode(methodCode);
    const found = shippingMethods.find((m) => {
        return m.carrier_code === decodedMethod.carrier_code;
    });

    return found || false;
}
